import Layout from '../../components/layout';
import routers from '../../router/router';

const state = {
  routes: [],
  routerMenus: [],
  alreayGeneraterMenus: false,
};

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.routes = routes;
  },
  SET_ROUTE_MENUS: (state, menus) => {
    state.routerMenus = menus;
  },
  UPDATE_MENUS_STATUS: (state, status) => {
    state.alreayGeneraterMenus = status;
  },
  ADD_MENU_ROUTES: (state, routes) => {
    state.routes = state.routes.concat(routes);
  },
};

const actions = {
  generateRoutes({ commit }, menus) {
    return new Promise((resolve) => {
      //let availableMneus = formatRouter(filterHiddenRouter(menus)); //过滤隐藏路由-格式化路由
      let slideMenus = JSON.parse(JSON.stringify(formatRouter(filterHiddenRouter(menus)))); //菜单

      let fullRouters = addLayout(formatRouter(menus)).concat(routers);

      commit('SET_ROUTES', fullRouters);
      commit('SET_ROUTE_MENUS', slideMenus);
      commit('UPDATE_MENUS_STATUS', true);
      resolve(fullRouters);
    });
  },

  updateMenusStatus({ commit }, status) {
    commit('UPDATE_MENUS_STATUS', status);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};

//过滤隐藏路由
function filterHiddenRouter(menus) {
  menus = JSON.parse(JSON.stringify(menus));
  menus = menus.filter((item) => {
    if (item.children && item.children.length) {
      item.children = filterHiddenRouter(item.children);
    }
    return item.is_show == 1;
  });
  return menus;
}

//格式化路由
function formatRouter(routers) {
  return routers.map((item) => {
    let obj = {
      path: item.path,
      //name: item.path.replace(/\//g, ''),
      meta: {
        title: item.title,
        icon: item.icon,
        noCache: item.is_cache == 2,
      },
      hidden: item.is_show == 2,
      component: () => import(`@/pages${item.path}`),
    };
    if (item.children && item.children.length > 0) {
      obj.children = formatRouter(item.children, obj);
    }
    return obj;
  });
}

//路由添加公共布局
function addLayout(routers) {
  let _routers = [];
  deep(routers);
  function deep(routers) {
    routers.forEach((router) => {
      if (Array.isArray(router.children) && router.children.length > 0) {
        deep(router.children);
      } else {
        let path = router.path.split('/');
        router.path = path[path.length - 1];
        _routers.push({
          path: '/' + path[1],
          //name: path[1],
          redirect: `/${path[1]}/${path[1]}`,
          component: Layout,
          children: [router],
        });
      }
    });
  }
  return _routers;
}
